/**
 * @generated SignedSource<<659977802f87db742b02c9caf53bc30b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpSharedRingSizeDetail_detailValues$data = ReadonlyArray<{
  readonly detailKey: string | null;
  readonly browseUrl?: string | null;
  readonly ringSizes?: ReadonlyArray<{
    readonly unit: string | null;
    readonly value: string | null;
  } | null> | null;
  readonly " $fragmentType": "PdpSharedRingSizeDetail_detailValues";
}>;
export type PdpSharedRingSizeDetail_detailValues$key = ReadonlyArray<{
  readonly " $data"?: PdpSharedRingSizeDetail_detailValues$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedRingSizeDetail_detailValues">;
}>;

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "PdpSharedRingSizeDetail_detailValues",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "detailKey",
      "storageKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "browseUrl",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "RingSizeDetail",
          "kind": "LinkedField",
          "name": "ringSizes",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "unit",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "value",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "PdpDetailRingSize",
      "abstractKey": null
    }
  ],
  "type": "PdpDetailValueInterface",
  "abstractKey": "__isPdpDetailValueInterface"
};

(node as any).hash = "3623ab36a1a6cb09c51800a820952000";

export default node;
